/** QQ官方机器人配置。凭据仅用于服务器连接，不作为会话身份。 */
export interface QQConfig {
  enabled: boolean;
  appId: string;
  appSecret: string;
  debug?: boolean;
}
/** 实例连接状态；只有SDK连接成功才能标记在线。 */
export interface QQGatewayStatus {
  connected: boolean;
  startedAt: number | null;
  lastError: string | null;
  lastInboundAt: number | null;
  lastOutboundAt: number | null;
}
export const DEFAULT_QQ_CONFIG: QQConfig = { enabled: false, appId: '', appSecret: '', debug: false };
export const DEFAULT_QQ_STATUS: QQGatewayStatus = { connected: false, startedAt: null, lastError: null, lastInboundAt: null, lastOutboundAt: null };
